import { configs } from '@configs'

/**
 * Constructs a complete image URL from a potentially relative path
 * @param imagePath - The image path (can be relative or absolute)
 * @returns Complete URL string
 */
export const buildImageUrl = (imagePath?: string): string => {
  if (!imagePath) return ''

  // If the path already starts with http, return as-is
  if (imagePath.startsWith('http')) {
    return imagePath
  }

  // Otherwise, prepend the AEM site URL
  return `${configs.mk.aemSiteUrl}${imagePath}`
}
